var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.625C3.39453 0.625 0.5 3.54492 0.5 7.125C0.5 10.7305 3.39453 13.625 7 13.625C10.5801 13.625 13.5 10.7305 13.5 7.125C13.5 3.54492 10.5801 0.625 7 0.625ZM7 3.875C7.43164 3.875 7.8125 4.25586 7.8125 4.6875C7.8125 5.14453 7.43164 5.5 7 5.5C6.54297 5.5 6.1875 5.14453 6.1875 4.6875C6.1875 4.25586 6.54297 3.875 7 3.875ZM8.01562 10.375H5.98438C5.62891 10.375 5.375 10.1211 5.375 9.76562C5.375 9.43555 5.62891 9.15625 5.98438 9.15625H6.39062V7.53125H6.1875C5.83203 7.53125 5.57812 7.27734 5.57812 6.92188C5.57812 6.5918 5.83203 6.3125 6.1875 6.3125H7C7.33008 6.3125 7.60938 6.5918 7.60938 6.92188V9.15625H8.01562C8.3457 9.15625 8.625 9.43555 8.625 9.76562C8.625 10.1211 8.3457 10.375 8.01562 10.375Z",
    fill: "#00A4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.23b99036ffd8c5f2e733f68be58107c2.svg";
export { ForwardRef as ReactComponent };